import { CallApi } from "app/_helpers/CallApi/CallApi";
import { RestMethod } from "../../_helpers/ApiConfig/RestMethod";
import { USER_DATA_CONSTANT } from "app/_constants/Redux/userData.constant";
import configureStore from "../../redux/Store";
// import FilterResponse from '../../_helpers/FilterResponse'
// import toastr from 'toastr'
import toastr from "toastr";
export const UserService = {
  getUsers,
  getStateByCountryID,
  getBlockByStateID,
  getLocationByBlockID,
  getWellInfoByLocationID,
  getActivityOperationMaster,
  addUser,
  getUserByID,
  updateUser,
  managePermissions,
  getPermissionList,
  manageProjects,
  updateEHSPermissions,
  deleteUser,
  login,
  activeUser,
  approveUser,
  sendEmailToUser,
  // logged user
  loggedUser,
  editLoggedUser,
  changePasswordOfLoggedUser,
  getGlobalPermissionList,
  globalPermissions,
  getUserNotifications,
  updateNotificationReadStatus,
  getVFLOfficers,
  enableMobileToUser,
  sendMobileLinkEmailToUser,
  downloadMobileApp,
  signOutUser,
};

async function getUserNotifications(filter) {
  let filter_key = filter ? filter : "";
  try {
    const response = await RestMethod.GET(
      "/global-configuration/ehs-module/user-notifications?" + filter_key
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
async function updateNotificationReadStatus(id) {
  // let filter_key = filter ? filter : "";
  try {
    const response = await RestMethod.POST(
      "/global-configuration/ehs-module/update-notification/" + id
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
async function getClientdata(filter) {
  let filter_key = filter ? filter : "";
  try {
    const response = await RestMethod.GET("/users/client?" + filter_key);
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
async function getIeddata(filter) {
  let filter_key = filter ? filter : "";
  try {
    const response = await RestMethod.GET("/users/ied");
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
async function getUsers(filter) {
  let filter_key = filter ? filter : "";
  try {
    const response = await RestMethod.GET("/users?" + filter_key);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getVFLOfficers() {
  let url = "/global-configuration/ehs-module/vlf-officer";
  return await CallApi(url, "GET");
}

async function getStateByCountryID(projectId, countryId) {
  try {
    const response = await RestMethod.GET(
      "/configuration/" + projectId + "/master/state/" + countryId
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
async function getBlockByStateID(projectId, stateId) {
  try {
    const response = await RestMethod.GET(
      "/configuration/" + projectId + "/master/block/" + stateId
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getLocationByBlockID(projectId, blockId) {
  try {
    const response = await RestMethod.GET(
      "/configuration/" + projectId + "/master/location/" + blockId
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getWellInfoByLocationID(projectId, locationId) {
  try {
    const response = await RestMethod.GET(
      "/configuration/" + projectId + "/master/wellInfo/" + locationId
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getActivityOperationMaster(projectId) {
  try {
    const response = await RestMethod.GET(
      "configuration/" + projectId + "/master/activityOperationMaster"
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

/************************************ User Management**************************************************/

async function addUser(data) {
  try {
    const response = await RestMethod.POST("/users/add-user", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function login(data) {
  try {
    const response = await RestMethod.POST("/users/login", data);
    if (response?.data?.status) {
      let { Store } = configureStore();

      Store.dispatch({
        type: USER_DATA_CONSTANT.DESTROY,
      });
    }
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function updateUser(id, data) {
  try {
    const response = await RestMethod.PUT("/users/" + id, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function deleteUser(id, data) {
  try {
    const response = await RestMethod.DELETE("/users/" + id);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getUserByID(id) {
  try {
    const response = await RestMethod.GET("/users/" + id);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getPermissionList() {
  try {
    const response = await RestMethod.GET("/users/permission-list");
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getGlobalPermissionList() {
  try {
    const response = await RestMethod.GET("/users/global-permission-list");
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function globalPermissions(id, data) {
  try {
    const response = await RestMethod.PUT("/users/global-permissions/" + id, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function managePermissions(id, data) {
  try {
    const response = await RestMethod.PUT("/users/manage-permissions/" + id, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function manageProjects(id, data) {
  try {
    const response = await RestMethod.PUT("/users/manage-projects/" + id, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function updateEHSPermissions(id, data) {
  try {
    const response = await RestMethod.PUT("/users/ehs-permissions/" + id, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function activeUser(id, data) {
  try {
    const response = await RestMethod.PUT("/users/active/" + id, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function approveUser(id, data) {
  try {
    const response = await RestMethod.PUT("/users/approve/" + id, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function sendEmailToUser(data) {
  try {
    const response = await RestMethod.PUT("/users/resent-user-email", data);
    return response;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function signOutUser(data) {
  try {
    const response = await RestMethod.POST("/users/account/sign-out", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function sendMobileLinkEmailToUser(id) {
  try {
    const response = await RestMethod.PUT("/users/mobile-link-email/" + id);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function downloadMobileApp() {
  try {
    const response = await RestMethod.GET("/users/download/mobile-app");
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function enableMobileToUser(id, data) {
  try {
    const response = await RestMethod.PUT("/users/enable-mobile/" + id, data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

/************************************ Logged User**************************************************/
async function loggedUser() {
  try {
    const response = await RestMethod.GET("/users/self/user");
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function editLoggedUser(data) {
  try {
    const response = await RestMethod.PUT("/users/self/user", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function changePasswordOfLoggedUser(data) {
  try {
    const response = await RestMethod.POST("/users/self/change-password", data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
